import InternetAndMobileRedesignShowcase from "./components/InternetAndMobileRedesignShowcase.vue";

const root = document.getElementById("internet-and-mobile-offers-redesign");

window.app = new Vue({
    el: root,
    name: 'InternetAndMobileOffersRedesign',
    components: {
        InternetAndMobileRedesignShowcase,
    },
    data: {
        pageVue: JSON.parse(root.dataset.pageVue),
        token: root.dataset.token
    }
});
